import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { HeartIcon } from 'components'

import { default as DefaultModal } from 'components/AuthModal/components/Modal'
import Overlay from 'components/AuthModal/components/Overlay'
import { OVERLAY } from 'components/AuthModal/styles'

const PointsInfo = ({ show, onClose }) => (
  <Overlay show={show} className={OVERLAY} preventEscBackdropClose={true} onClose={() => onClose()}>
    <DefaultModal innerClassName="overflow-y-scroll flex flex-col justify-center px-5">
      <div className="relative h-auto flex flex-col items-center text-white w-full rounded-xl bg-woodsmokeBlackDarker w-58 text-center">
        <div className="p-5 pb-3">
          <div className="mb-2 text-lg">TELEPORT TOKENS</div>
          <div className="text-sm leading-10">
            Tokens are the heart of TELEPORT.
            <br />
            Use tokens to attract with intention.
            <br />
            Tokens prioritize the waitlist.
            <br />
            Tokens will hold real value.
          </div>
        </div>
        <button
          className="py-4 bg-transparent text-white text-base w-full border-t border-solid border-white border-opacity-20"
          onClick={() => onClose()}
        >
          close
        </button>
      </div>
    </DefaultModal>
  </Overlay>
)

const Points = ({ points, primary, className, ...rest }) => {
  const [showInfo, setShowInfo] = useState()

  return (
    <>
      <button
        className={classnames(
          'flex items-center justify-center text-base text-white py-0.5 px-4 rounded-full text-center bg-black border-2 border-solid border-heath',
          className
        )}
        onClick={() => setShowInfo(true)}
        {...rest}
      >
        <span className="mr-2">{points}</span>
        <HeartIcon
          className={classnames('h-3 w-3', {
            'text-white': !primary,
            'text-frolyPink': primary,
          })}
        />
      </button>
      <PointsInfo show={showInfo} onClose={() => setShowInfo(false)} />
    </>
  )
}

PointsInfo.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
}

Points.propTypes = {
  points: PropTypes.oneOf(PropTypes.string, PropTypes.number),
  className: PropTypes.string,
  primary: PropTypes.bool,
}

export default Points
